var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#006DEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5714 29.4286H29.4286V36.5714C29.4286 36.9503 29.2781 37.3137 29.0102 37.5816C28.7422 37.8495 28.3789 38 28 38C27.6211 38 27.2578 37.8495 26.9898 37.5816C26.7219 37.3137 26.5714 36.9503 26.5714 36.5714V29.4286H19.4286C19.0497 29.4286 18.6863 29.2781 18.4184 29.0102C18.1505 28.7422 18 28.3789 18 28C18 27.6211 18.1505 27.2578 18.4184 26.9898C18.6863 26.7219 19.0497 26.5714 19.4286 26.5714H26.5714V19.4286C26.5714 19.0497 26.7219 18.6863 26.9898 18.4184C27.2578 18.1505 27.6211 18 28 18C28.3789 18 28.7422 18.1505 29.0102 18.4184C29.2781 18.6863 29.4286 19.0497 29.4286 19.4286V26.5714H36.5714C36.9503 26.5714 37.3137 26.7219 37.5816 26.9898C37.8495 27.2578 38 27.6211 38 28C38 28.3789 37.8495 28.7422 37.5816 29.0102C37.3137 29.2781 36.9503 29.4286 36.5714 29.4286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionPlus);
export default __webpack_public_path__ + "static/media/accordion-plus.c01ae32bd4f8736016d25416fd10811b.svg";
export { ForwardRef as ReactComponent };